import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { Card, GrayCardTitle } from "../../common_components/Layout";
import Modal from "../../common_components/Modal";
import { PrimaryButton, SecondaryButton } from "../../common_components/Buttons";

// Api Calls
import MissionUserListAPI from "../../../api/api_calls/MissionUserListsAPI";

function ReviewUserApprovalCard(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, appId } = useParams()


    // Approval Function
    function onApproval() {
        async function approveUser() {
            const result = await MissionUserListAPI.approve_user({ missionId, missionUserListId: appId, handleRedirect: navigate });

            if (result.success) {
                alert.show("User Approved. They will be notified and asked to schedule", { type: 'success' })
                navigate("/missions/" + missionId + "/reviewusers/")
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        approveUser();
    }


    // Reject Modal State
    const [rejectModalIsOpen, setRejectModalIsOpen] = useState(false);
    const toggleRejectModal = () => {
        setRejectModalIsOpen(!rejectModalIsOpen);
    }
    function onRejectConfirm() {
        async function rejectApplication() {
            const result = await MissionUserListAPI.reject_user({ missionId, missionUserListId: appId, handleRedirect: navigate });

            if (result.success) {
                alert.show("User rejected.", { type: 'success' })
                navigate("/missions/" + missionId + "/reviewusers/")
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        rejectApplication();
    }

    return (
        <Card>
            <GrayCardTitle title="Actions" />
            <div className="gray-text">
                Approve or reject this user for this project.
            </div>
            <div className="session-button-row">
                <PrimaryButton text="Approve User" onClick={onApproval} />
                <SecondaryButton text="Reject User" onClick={toggleRejectModal} />
            </div>
            <div className="modal-holder">
                {rejectModalIsOpen && <RejectModal isOpen={rejectModalIsOpen} toggleModal={toggleRejectModal} onConfirm={onRejectConfirm} />}
            </div>

        </Card>
    )
}

function RejectModal(props) {
    var style = {
        maxWidth: "350px",
        gap: "32px"
    }

    if (window.innerWidth < 768) {
        style.maxWidth = "100%";
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen}>
            <Card style={style}>
                <div className="modal-title">
                    Reject User?
                </div>
                <div className="modal-text mw-">
                    Reject this user? They won't be able to participate in this project.                </div>
                <div className="button-row-right">
                    <PrimaryButton text="Confirm" onClick={props.onConfirm} />
                    <SecondaryButton text="Close" onClick={props.toggleModal} />
                </div>
            </Card>
        </Modal>
    )
}


export default ReviewUserApprovalCard;